module.exports = __webpack_public_path__ + "img/l_logo2.96c359c4.png";